const sanitizeToken = (rawToken) => {
  if (!rawToken) {
    return "";
  }
  return rawToken.replace(/^"|"$/g, "").trim();
};

export const attachAuthHeader = (headers, rawToken) => {
  try {
    const token = sanitizeToken(rawToken);

    if (!token) {
      return { headers, applied: false };
    }

    const value = `Bearer ${token}`;

    if (!headers) {
      return {
        headers: { Authorization: value },
        applied: true
      };
    }

    const candidate = headers;
    if (typeof candidate.set === "function") {
      candidate.set("Authorization", value);
      return { headers, applied: true };
    }

    return {
      headers: {
        ...headers,
        Authorization: value
      },
      applied: true
    };
  } catch (_) {
    return { headers, applied: false };
  }
};

export default attachAuthHeader;
